angular.module('impactx.account').directive('ibanInput', ['$filter', function($filter) {
    /**
     * Attribute directive that formats user input by adding whitespaces after every specified number of characters.
     * And adds a maxlength to the IBAN input.
     *
     * @param scope The scope.
     * @param element The input-element.
     * @param attr The attributes of the input.
     * @param modelCtrl The required model controller.
     */
    const IBANlength = 31;
    const IBANTextlength = IBANlength + Math.floor(IBANlength/4);
    var formatInput = function(scope, element, attr, modelCtrl) {
        var onBlurFunc,
            filter = 'ibanFilter';

        modelCtrl.$formatters.push(function() {
            return $filter(filter)(modelCtrl.$modelValue);
        });

        modelCtrl.$parsers.push(function(data) {

            var rawInput = data.toString();
            var validInput = rawInput.replace(/ /g, '');
            var cursorPos = getCursor(element);
            var formattedInput = $filter(filter)(validInput);
            element.val(formattedInput);
            var posMod = formattedInput.length - rawInput.length;
            setCursor(element, cursorPos + posMod);
            return validInput;
        });

        onBlurFunc = function() {
            var formattedInput,
                input = element.val();

            formattedInput = $filter(filter)(input);

            element.val(formattedInput);

            modelCtrl.$modelValue = formattedInput;

            modelCtrl.$render();

        };

        element.attr("maxlength", IBANTextlength);
        element.bind('blur', onBlurFunc);
        //Unbinding on $destroy event failed. jQuery doesn't like it.
    };

    var getCursor = function(el) {
        return el.prop('selectionStart');
    };

    var setCursor = function(el, pos) {
        el.prop('selectionStart', pos);
        el.prop('selectionEnd', pos);
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: formatInput,
        scope: {}
    };
}]);